export enum ImportStatus {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	ERROR = 'ERROR',
}

export enum ImportType {
	DESTINATION = 'DESTINATION',
	TRANSFER = 'TRANSFER',
}

export enum ImportRecordStatus {
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
}

export interface DestinationImportData {
	documento: string;
	nome_do_beneficiario: string;
	tipo_de_movimentacao: string;
	tipo_de_chave: string;
	chave_pix: string;
	tipo_de_conta: string;
	ispb: string;
	agencia: string;
	conta: string;
}

export interface TransferImportData {
	id: string;
	documento: string;
	nome_do_beneficiario: string;
	tipo_de_movimentacao: string;
	tipo_de_chave: string;
	chave_pix: string;
	tipo_de_conta: string;
	ispb: string;
	agencia: string;
	conta: string;
	valor: number;
	data_agendamento: string;
	descricao?: string;
}

export interface DestinationImportRecord {
	data: DestinationImportData;
	status: ImportRecordStatus;
	error: string | null;
}

export interface TransferImportRecord {
	data: TransferImportData;
	status: ImportRecordStatus;
	error: string | null;
}

export type ImportRecord = DestinationImportRecord | TransferImportRecord;

interface ImportBase {
	id: string;
	status: ImportStatus;
}

export type Import =
	| (ImportBase & {
		type: ImportType.DESTINATION;
		records: DestinationImportRecord[];
	})
	| (ImportBase & {
		type: ImportType.TRANSFER;
		records: TransferImportRecord[];
	});
